import { Button } from "react-bootstrap";

import { SaveIcon } from "../../constants/icon_path";

const IconButton = ({
  onClick,
  variant = "primary",
  iconColor = "white",
  text,
  iconSize = 20,
  className,
}) => {
  return (
    <Button variant={variant} onClick={onClick} className={className}>
      <SaveIcon size={iconSize} color={iconColor} />
      <span className="p-2">{text}</span>
    </Button>
  );
};

export default IconButton;
